import { jsxs as v, jsx as p } from "react/jsx-runtime";
import { forwardRef as E, useRef as N, useCallback as R, useImperativeHandle as x, useEffect as I } from "react";
import K from "classnames";
import M from "../builders-icons/dist/systems/close.js";
import { useTracking as T } from "../utils.js";
import i from "./modal.module.less.js";
let n = !1;
const Y = E(function({
  children: g,
  className: b,
  closeLabel: a,
  open: u = !1,
  size: h = "lg",
  strict: d = !1,
  tracking: w = !0,
  variant: l = "box",
  ...r
}, y) {
  const f = N(null), m = T(w), o = R(
    (t, s = "_dismiss") => {
      const e = f.current, c = typeof (e == null ? void 0 : e.close) == "function";
      !e || e.hidden !== t || (c ? e[t ? "showModal" : "close"]() : t || e.dispatchEvent(new CustomEvent("close")), e.hidden = !t, t && setTimeout(() => e.focus()), m({
        eventCategory: `modal_${l}`,
        eventAction: t ? "open" : `close${s}`,
        eventLabel: (e == null ? void 0 : e.getAttribute("aria-label")) || "modal"
      }));
    },
    [l, m]
  );
  return x(y, () => f.current), I(() => o(u, ""), [u, o]), /* @__PURE__ */ v(
    "dialog",
    {
      ...r,
      hidden: !0,
      className: K(
        i.dialog,
        i[l],
        i[h],
        b
      ),
      onKeyDown: (t) => {
        r.onKeyDown && r.onKeyDown(t), t.key === "Escape" && (t.preventDefault(), d || o(!1));
      },
      onPointerDown: ({ clientX: t, clientY: s, currentTarget: e }) => {
        const { top: c, left: k, right: C, bottom: D } = e.getBoundingClientRect();
        n = c <= s && k <= t && s <= D && t <= C ? "inside" : "outside";
      },
      onClick: () => {
        n === "outside" && !d && o(!1), n && (n = !1);
      },
      ref: f,
      children: [
        a && /* @__PURE__ */ p(
          "button",
          {
            "aria-label": a,
            className: i.close,
            onClick: () => o(!1),
            type: "button",
            children: /* @__PURE__ */ p(M, {})
          }
        ),
        g
      ]
    }
  );
});
export {
  Y as Modal
};
//# sourceMappingURL=modal.js.map
